import React, {PropTypes} from 'react';
import StandardModal from 'shared/StandardModal.jsx';

const EventPriceDetailsModal = ({
  visible,
  basePrice,
  fees,
  onCancelClick
}) =>(
  <StandardModal
    title="Price Breakdown"
    visible={visible}
    onCloseClick={onCancelClick}>
    <div className="list-group">
      <div className="list-group-item-labeled">
        <div
          className="list-group-item-labeled-child"
          style={{width: 200}}>
          <span>{'Description'}</span>
          <span>{'Event'}</span>
        </div>
        <div
          className="list-group-item-labeled-child"
          style={{width: 125}}>
          <span>{'Amount ($)'}</span>
          <span>{basePrice}</span>
        </div>
      </div>
      {fees.map((item, index) => (
        <div
          key={index}
          className="list-group-item-labeled">
          <div
            className="list-group-item-labeled-child"
            style={{width: 200}}>
            <span>{'Description'}</span>
            <span>{item.description}</span>
          </div>
          <div
            className="list-group-item-labeled-child"
            style={{width: 125}}>
            <span>{'Amount ($)'}</span>
            <span>{item.fee}</span>
          </div>
        </div>
      ))}
      <br />
      <div className="text-right">
        <button
          type="button"
          className="btn btn-primary btn-lg"
          onClick={onCancelClick}
        >{`Close`}</button>
      </div>
    </div>
  </StandardModal>
);

EventPriceDetailsModal.propTypes = {
  visible: PropTypes.bool,
  basePrice: PropTypes.number,
  fees: PropTypes.arrayOf(PropTypes.object),
  onCancelClick: PropTypes.func
};

EventPriceDetailsModal.defaultProps = {
  basePrice: 0,
  fees: []
};

export default EventPriceDetailsModal;



// WEBPACK FOOTER //
// ./src/features/shared/eventPriceDetailsModal/EventPriceDetailsModal.jsx